import template from './employee_view.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_id = ko.observable();
		this.employee = ko.observable();
		this.records = ko.observableArray();
		this.employee_fields = ko.observableArray();
		this.leave_date_overlaps = ko.observable('false');
		this.is_viewing_own_profile = ko.observable('false');
		this.employeeEventDates = ko.observable([]);
		this.title = ko.computed(() => {
			let translated = tr('My Profile');

			if (this.is_viewing_own_profile() == 'true')
				return translated;
			else if (this.is_viewing_own_profile() == 'false')
			{
				if (this.employee())
					return tr('Profile: ') + this.employee().firstname + (this.employee().surname ? ' ' + this.employee().surname : '');
			}
		});

		// user roles
		this.access_roles = ko.observableArray();
		this.is_app_invite_visible = ko.observable(false);

		// TABS
		this.selected_tab = ko.observable(localStorage.getItem('last-profile-tab') || 'general');
		this.employment_tab = ko.observable(true);
		this.current_tab = ko.observable();
		this.management_tab = ko.observable(true);
		this.general_tab = ko.observable(true);
		this.documents_tab = ko.observable(true);
		this.registered_status = ko.observable();
		this.pending_resignation = ko.observable(false);
		this.end_date = ko.observable();
		this.has_general_tab_access = ko.observable(false);
		this.has_view_other_profile = ko.observable(false);

		let url_hash = window.location.hash.split('#').pop();

		let valid_tabs = [
			'general',
			'employee_documents', 
			'employee_employment', 
			'management', 
			'leave', 
			'employee_notes', 
			'bursaries',
			'systems',
			'employee_log', 
			'performance_management', 
			'employee_remuneration',
			'employee_disciplinary', 
			'timemanagement'
		  ];
		let stored_tab = localStorage.getItem('last-profile-tab');
		let default_tab = valid_tabs.includes(url_hash) ? url_hash : (valid_tabs.includes(stored_tab) ? stored_tab : 'general');

		this.selected_tab(default_tab);

		this.selected_tab.subscribe((val) => {
			$('.ps-tabs > li').removeClass('active');
			$(`.ps-tabs > li[data-tabname=${val}]`).addClass('active');
		});

		$(`.ps-tabs > li[data-tabname=${this.selected_tab()}]`).addClass('active');

		this.onCompReload_click = this.onCompReload_click.bind(this);
	}

	async onCompReload_click()
	{
		await this.reload_comp(); 
	};

	//fetch the access check for general tab or view other profile feature 

	async init_feature_access() {
		try {
        this.has_general_tab_access(await Permissions.checkAccessRights('EmployeeProfileGeneralTab'));
    } catch (error) {
        console.error('Error checking feature access:', error);
        this.has_general_tab_access(false);
    }

    try {
        this.has_view_other_profile(await Permissions.checkAccessRights('ViewOtherProfile'));
    } catch (error) {
        console.error('Error checking feature access:', error);
        this.has_view_other_profile(false);
    }

    // Validate current selected tab is still accessible
    await this.validateSelectedTab();
	}

	async validateSelectedTab() {
		let currentTab = this.selected_tab();
		let tabFeatureMap = {
			'employee_documents': 'EmployeeProfileDocumentsTab',
			'employee_employment': 'EmployeeProfileEmploymentTab',
			'management': 'EmployeeProfileManagementTab',
			'leave': 'EmployeeProfileLeaveTab',
			'employee_notes': 'EmployeeNotes',
			'bursaries': 'EmployeeBursariesAdministation',
			'systems': 'EmployeeLinkSystem',
			'employee_log': 'EmployeeHistoryLog',
			'performance_management': 'EmployeeProfilePerformanceManagementTab',
			'employee_remuneration': 'EmployeeProfileRemunerationTab',
			'employee_disciplinary': 'EmployeeProfileDisciplinaryTab',
			'timemanagement': 'TimeManagementLog'
		};

		// Check if current tab requires a feature and if user has access to it
		if (tabFeatureMap[currentTab]) {
			try {
				let hasAccess = await Permissions.checkAccessRights(tabFeatureMap[currentTab]);
				if (!hasAccess) {
					// User lost access to this tab, reset to general
					this.selected_tab('general');
					localStorage.setItem('last-profile-tab', 'general');
				}
			} catch (error) {
				// If there's an error checking access, reset to general
				this.selected_tab('general');
				localStorage.setItem('last-profile-tab', 'general');
			}
		} else if (currentTab === 'general') {
			// Check if user has access to general tab
			if (!this.has_general_tab_access() && !this.has_view_other_profile()) {
				// User doesn't have access to general, find first accessible tab
				for (let [tab, feature] of Object.entries(tabFeatureMap)) {
					try {
						let hasAccess = await Permissions.checkAccessRights(feature);
						if (hasAccess) {
							this.selected_tab(tab);
							localStorage.setItem('last-profile-tab', tab);
							break;
						}
					} catch (error) {
						continue;
					}
				}
			}
		}
	}
	switch_tabs (data, event)
	{
		let tab_name = event.currentTarget.getAttribute('data-tabname');
		localStorage.setItem('last-profile-tab', tab_name);
		this.selected_tab(tab_name);
		//document.querySelectorAll('.ps-tabs li').forEach(tab => tab.classList.remove('active'));
		//event.currentTarget.classList.add('active');
	}

	async loadData()
	{
		if (Permissions.isLoggedInUser_ExternalManager() == true)
		{
			$('#employee_employment-tab').tab('show');
		}

		this.is_viewing_own_profile((Utils.get_local_storage_nullable('employee_id') == this.page.bindings.id) ? 'true' : 'false');

		if (Utils.get_local_storage_nullable('employee_id') != this.page.bindings.id)
		{
			if (Permissions.isLoggedInUser_AssistantManager())
				$('#leave-tab').tab('show');
		}

		let res = await Grape.fetches.postJSON('/employee/allowed_to_access/', { 'employee_id': this.page.bindings.id });

		if (res.status == 'OK')
			await this.loadPage();
		else if (res.status == 'ERROR')
			await Grape.navigate('/employee/view/-1');
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error', 'Error') });
	}

	async loadPage()
	{
		await this.load_employee();
		//await this.alignEmployeePhoto();
	}

	async reload_comp()
	{
		await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 0.5 seconds
		await this.loadData(); 
	}

	async load_employee()
	{
		this.employee(null);
		this.pending_resignation(false);
		let employee_id = this.page.bindings.id;
		let res = await Grape.fetches.getJSON('/employee/' + employee_id, {});

		this.registered_status(res.employee.registered_status);

		document.title = tr('Profile')+': ' + res.employee.firstname + (res.employee.surname ? ' ' + res.employee.surname : '');
		let employee = res.employee;

		this.employee(employee);
		this.employee_fields(employee.fields);

		//Utils.refresh_data_visible_roles();

		res = await Grape.fetches.postJSON('/leave/get_holidays', { 'employee_id': this.page.bindings.id });
		this.employeeEventDates(Utils.parseEmployeeHolidayDates(res.get_holidays));

		if (this.page.bindings.linked_leave_tutorial == 'startleavetypetutorial=true')
			await this.start_linked_leave_tutorial();

		let res_process = await Grape.fetches.getJSON('/grape-processes/resign_employee_scheduled/active_schedules', {process_name: 'resign_employee_scheduled'});
		if (res_process.new)
		{
			for (let p = 0; p < res_process.new.length; p++)
			{
				if (employee_id == res_process.new[p].param.employee_id)
				{
					this.pending_resignation(true);
					this.end_date(res_process.new[p].param.end_date);
				}
			}
		}
	}

	async start_employee_page_intro()
	{
		let result = await Grape.fetches.getJSON('/api/setting/system.tutorial_start_employee_page_intro', {});
		if (result.value == 'true' && Permissions.isLoggedInUser_Admin() && this.page.bindings.linked_leave_tutorial != 'startleavetypetutorial=true')
		{
			var options_before = {
				steps: [{
						element: '#the-basics',
						intro: 'You can search for more employees here!'
					},{
						element: '#profile',
						intro: 'This is your employees profile details (Name and Surname,Department and Designation)!'
					},{
						element: '#general-tab',
						intro: 'This is the General tab where you can add and edit employee details!'
					},{
						element: '#help-sign',
						intro: 'This is a help icon, click on these to find out more information on the current section!'
					},{
						element: '#edit-employee-details',
						intro: 'Here you can edit employee details!'
					},{
						element: '#edit-employee-details-dropdown',
						intro: 'Here you can add a profile picture and send this  employee an invtiation to the system!'
					},{
						element: '#employee-documents-tab',
						intro: 'This is the Documents tab where you can edit and add employee documents!'
					},{
						element: '#employee-renumeration-tab',
						intro: 'This is the renumeration tab where you can view employee renumeration!'
					},{
						element: '#employee_employment-tab',
						intro: 'This is the Employment tab where you can add and edit Employee Designation and Department!'
					},{
						element: '#management-tab',
						intro: 'This is the Management tab where you can add and edit managers or add edit subordinates!'
					},{
						element: '#employeenotes-tab',
						intro: 'This is the Notes tab where you can add and edit Employee Notes!'
					},{
						element: '#bursaries-tab',
						intro: 'This is the bursaries tab where you can add and edit Employee Bursaries!'
					},{
						element: '#employeelog-tab',
						intro: 'This is the History tab where you can view an audit history for this employee!'
					},,{
						element: '#employee-disciplinary-tab',
						intro: 'This is the Disciplinary tab where you can view employee warnings and disciplinaries!'
					}
				]
			};

			var intro = introJs();
			intro.setOptions(options_before);
			intro.start().onexit(async function()
			{
				await Grape.fetches.postJSON('/api/setting', { name: 'system.tutorial_start_employee_page_intro', value: false });
			});
		}
	}

	async navigate_to_time_log()
	{
		let employee_id = this.page.bindings.id;
		let employee_name = this.employee().firstname + ' ' + this.employee().surname;
		Grape.navigate('/time_management/time_view', { employee_id: employee_id, employee_name: employee_name });
	}

	async start_employment_tab_intro()
	{
		let result = await Grape.fetches.getJSON('/api/setting/system.tutorial_start_employment_intro', {});
		if (result.value == 'true' && Permissions.isLoggedInUser_Admin())
		{
			let options_before = {
				steps: [
					{
						element: '#add-department',
						intro: 'You can add and edit Employee Designation and Departments here!'
					}
				]
			};

			let intro = introJs();
			intro.setOptions(options_before);
			intro.start().onexit(async function()
			{
				await Grape.fetches.postJSON('/api/setting', { name: 'system.tutorial_start_employment_intro', value: false });
			});
		}
	}

	async start_management_tab_intro()
	{
		let result = await Grape.fetches.getJSON('/api/setting/system.tutorial_start_management_intro');
		if (result.value == 'true' && Permissions.isLoggedInUser_Admin())
		{
			var options_before = {
				steps: [{
						element: '#ViewManagers',
						intro: 'This section is for managers thats assigned to this employee!'
					},{
						element: '#add-manager-typeahead',
						intro: 'You can search for a manager to assign to this employee!'
					},{
						element: '#add-manager-button',
						intro: `When you're done searching click "ADD"`
					},{
						element: '#ViewManagedDepartments',
						intro: 'This section is for employees that manage departments!'
					},{
						element: '#SaveManagerDepartment',
						intro: `Click here to add a department this employee manages (only necessary for managers)`
					},{
						element: '#ViewManagedEmployees',
						intro: `This section is for employees thats assigned to this manager(The employees this user manages)!`
					},{
						element: '#typeahead_manager-add-subordinate',
						intro: `You can search for employee(s) to assign to this manager!`
					},{
						element: '#add_subordinate',
						intro: `When you're done searching click "ADD"`
				}]
			};

			var intro = introJs();
			intro.setOptions(options_before);
			intro.start().onexit(async() => {
				await Grape.fetches.postJSON('/api/setting', { name: 'system.tutorial_start_management_intro', value: false });
			});
		}
	}

	async start_leave_tab_intro()
	{
		let result = await Grape.fetches.getJSON('/api/setting/system.tutorial_start_leave_intro', {});
		if (result.value == 'true' && Permissions.isLoggedInUser_Admin())
		{
			var options_before = {
				steps: [{
						element: '#leave-summary',
						intro: 'This is the employees summary of how much leave they have (leave balances)!'
					},{
						element: '#leave_summary_date',
						intro: 'You can filter by date here.'
					},{
						element: '#link-leave',
						intro: 'You can link leave types to an employee here.'
					},{
						element: '#leave-taken-entries',
						intro: 'This is your employees leave taken history.'
					},{
						element: '#add-leave-manually',
						intro: 'You can manually add leave taken entries for an employee here'
					}]
			};

			var intro = introJs();
			intro.setOptions(options_before);
			intro.start().onexit(async() => {
				await Grape.fetches.postJSON('/api/save_setting', { name: 'system.tutorial_start_leave_intro', value: false });
			});
		}
	}

	async start_linked_leave_tutorial()
	{
		let result = await Grape.fetches.getJSON('/api/setting/system.tutorial_start_linked_leave_tutorial', {});
		if (result.value == 'true' && Permissions.isLoggedInUser_Admin())
		{
			$('#general-tab-li').removeClass('active');
			$('#general').removeClass('active');
			$('#leave-tab-li').addClass('active');
			$('#leave').addClass('active');
			$('#general-tab').removeClass('active');
			$('#leave-tab').addClass('active');
			$('#general-tab').removeClass('active');
			$('#general-tab').attr('aria-expanded', 'false');
			$('#leave-tab').attr('aria-expanded', 'true');

			var options_before = {
				steps: [
					{
						element: '#link-leave',
						intro: 'You can link leave types to an employee here.'
					}
				],
				exitOnOverlayClick: false,
				exitOnEsc: false,
				tooltipPosition: 'auto',
				showStepNumbers: false
			};
		};

		Grape.fetches.patchJSON = (url, data, callback) => {
			$.ajax({
				url: url,
				type: 'PATCH',
				contentType: 'application/json',
				data: JSON.stringify(data),
				success: callback,
				error: () => { },
			})
		}

			var intro = introJs();
			intro.setOptions(options_before);
			setTimeout(() => {
				if (document.getElementById('link-leave')) {
					try {
						intro.start().onexit(async () => {
							await Grape.fetches.patchJSON('/api/setting/' + 'system.tutorial_start_linked_leave_tutorial', { name: 'system.tutorial_start_linked_leave_tutorial', value: false })
						});
					} catch (error) {
						console.error('Failed to start tutorial:', error);
					}
				} else {
					console.log('Tutorial element not found. Skipping tutorial.');
				}
			}, 1000);
		}
	

	// to position the image
	async alignEmployeePhoto()
	{
		$('#employee_photo').hide();

		var photoInterval;

		var img = new Image();
		img.onload = () => {
			var imgthis = this;

			// loop until the dom is actually ready with image
			photoInterval = setInterval(() => {

				if ($('#employee_photo').width() > 0)
				{
					clearInterval(photoInterval);

					if (imgthis.width > imgthis.height)
					{
						$('#employee_photo').css('width', 'auto');
						$('#employee_photo').css('height', '150px');

						// now position
						var fat = $('#employee_photo').width() - 150;
						$('#employee_photo').css('left', (fat * 0.5 * -1) + 'px');	// move left by 50% of whats left
					} else
					{
						$('#employee_photo').css('width', '150px');
						$('#employee_photo').css('height', 'auto');

						// now position
						var fat = $('#employee_photo').height() - 150;
						$('#employee_photo').css('top', (fat * 0.3 * -1) + 'px'); // move up by 30% of whats left
					}

					$('#employee_photo').show();
				}
			}, 100);
		};

		img.src = '/download/employee/' + this.page.bindings.id + '/photo';
	}
}

class EmployeePage
{
	constructor(bindings, element)
	{
		this.bindings = bindings;
		this.user_rights_call_count = 0;

		if (bindings.id == -1)
			bindings.id = Utils.get_local_storage_nullable('employee_id');

		this.viewModel = new EmployeeViewModel(this);
		this.viewModel.employee_id(bindings.id);
		
		this.get_employee = (o) => {
			Grape.navigate('/employee/view/' + o.employee_id);
		};

		/* XXX Hans - remove?
		this.getMyEmployeeId = function (o) {
			return o.employee_id;
		};
		*/
	}

	/* Approve user Requesting access */
	async approve_user(v, e)
	{
		var data = {
			employee_id: bindings.id,
			registered_status: 'approved'
		};
		let res = await Grape.fetches.postJSON('/employee/approve_user_access', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully approved user.', 'Successfully approved user.'), title: tr('Success', 'Success')});
			await this.viewModel.loadData();
		}
		else if (res.status == 'ERROR')
			Grape.alert_api_error(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};

	/* Unverified User Submit access approval */
	async submit_for_approval(v, e)
	{
		var data = {
			employee_id: bindings.id
		};

		let res = await Grape.fetches.postJSON('/employee/submit_profile_review', data);

		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: 'Successfully Submitted Review.', title: 'Success'});
			await this.viewModel.loadData();
		}
		else if (res.status == 'ERROR')
			Grape.alert_api_error(res);
		else
			Grape.alerts.alert({ type: 'error', message: 'Something went wrong...', title: 'Error' });
	};

	// Event (Post/After): Load once
	async init()
	{
		document.title = 'View Employee Profile';
		await this.viewModel.init_feature_access();
	}

	async updateData()
	{
		await this.viewModel.loadData();
		window.current_page_title(this.viewModel.title());
	}
}

export default {
	route: `[/]employee/view/:id/:linked_leave_tutorial`,
	page_class: EmployeePage,
	template: template,
	template_filename: 'translation/employee_view'
};